export function Resource(resource) {
    return function Resource(constructor) {
        constructor.resource = resource;
        return class extends constructor {
            constructor() {
                super(...arguments);
                this._resource = resource;
            }
        };
    };
}
//# sourceMappingURL=resource.js.map